import {HTTP} from "./util"

const customer = { customerCode : "" , customerName : "" , shopNumber : "" , streetNumber : "" ,
    countryCode : "" , countryName : "",
    streetName : "" , streetType : "" , city : "" , state : "" , postCode : "" };


const InternationalCustomerWrapper = {

    init : (config) => {

        return {
            validate : async function(data) {
                const url = `${config.url}/freight-customer/internationalcustomer/validate/agent`;

                let p = Promise.resolve();

                try{
                    let response = await HTTP.post(url,data);
                    if(response.ok){
                        let json = await response.json();
                        const value = {
                            success: true ,
                            status: response.status,
                            data: {
                                customerCode : json ?  json.customerCode : "" ,
                                name: json ?  json.customerName : "" ,
                                streetaddress : json ?  json.shopNumber + " " + json.streetNumber + " " + json.streetName + " " + json.streetType : "",
                                city : json ?  json.city : "",
                                state : json ?  json.state : "",
                                postcode : json ?  json.postCode : "",
                                country : { value :json ?   json.countryCode : "" , label :json ?   json.countryName : "" }
                            }
                        };
                        p = Promise.resolve(value)
                    }
                    else{
                        if(response.status >= 500 ){
                            p = Promise.reject({status : response.status , message : "Backend technical problem"});
                        }
                        else if( response.status === 404 ){
                            p = Promise.reject({status : response.status , message : "Sorry, we can't find your details"})
                        }
                    }
                }
                catch( e ){
                    p = Promise.reject({ status : 0 , message : e.message})
                }
                return p;

            }
        }
    }

};

const InternationalCustomer = (config) => {

    return InternationalCustomerWrapper.init(config)
};

export {

    InternationalCustomer
}